<script lang="ts">
  import AccordionChevron from '$icons/AccordionChevronIcon.svelte';
  import { tick } from 'svelte';
  import { fade } from 'svelte/transition';

  export let isExpanded = false;
  export let title: string;
  export let titleNumber: number = null;

  export function expand() {
    isExpanded = true;
    scrollIntoView();
  }

  function scrollIntoView() {
    tick().then(() => container?.scrollIntoView(true));
  }

  $: if (isExpanded) scrollIntoView();

  let container: HTMLElement;
</script>

<div class="border-[1px] border-grey-neutral-40 rounded-14 cursor-pointer" bind:this={container}>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="flex px-3 py-4 select-none items-center"
    on:click={() => (isExpanded = !isExpanded)}
    on:keypress={() => (isExpanded = !isExpanded)}
  >
    <div class="font-bold">
      {title}
    </div>

    {#if titleNumber !== null}
      <div
        class="px-1.5 bg-gray-100 overflow-visible text-sm relative ml-2 font-medium rounded-[5px] w-5 h-5 grid place-items-center"
      >
        {titleNumber}
      </div>
    {/if}

    <div class="flex-grow" />

    <div class:-rotate-90={!isExpanded} class="transition-transform duration-200">
      <AccordionChevron />
    </div>
  </div>

  {#if isExpanded}
    <div class="bg-grey-transparency-dark h-px opacity-[4%] mx-3" />

    <div in:fade class="px-3 mb-4">
      <slot />
    </div>
  {/if}
</div>
